import React from 'react';

const LatestList = ({ latestList }) => {
    // 最新順にソートし、件数を減算しながらリストを構築
    const filteredAndAdjustedList = [...latestList]
        .sort((a, b) => new Date(b.appoint_time) - new Date(a.appoint_time)) // 最新順にソート
        .reduce((acc, current) => {
            // 名前ごとの減算カウンタを追跡
            const existingCount = acc.filter(item => item.TLAP_name === current.TLAP_name).length;

            // 減算された件数を計算
            const adjustedCount = current.appoint_count - existingCount;

            // 減算結果が0以上ならリストに追加
            if (adjustedCount > 0) {
                acc.push({
                    ...current,
                    appoint_count: adjustedCount,
                });
            }

            return acc;
        }, [])
        .filter(item => !item.TLAP_name.includes('SV') && item.appoint_count > 0) // フィルタ条件
        .slice(0, 10); // 上位10件のみ取得

    // 時刻フォーマッタ
    const formatTime = (datetime) => {
        const date = new Date(datetime);
        return `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
    };

    return (
        <div className="latest_list">
            <h1>最新獲得順</h1>
            <table className="latest_table">
                <thead className="latest_header">
                    <tr>
                        <th>時間</th>
                        <th>グループ</th>
                        <th>名前</th>
                        <th>件数</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredAndAdjustedList.map((item, index) => (
                        <tr key={index} className="latest_row">
                            <td>{formatTime(item.appoint_time)}</td>
                            <td>{item.group}</td>
                            <td>{item.TLAP_name}</td>
                            <td>{item.appoint_count}件</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LatestList;
